module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0107.jpg?v=742eb25f";